/* ==========================================================================
   CUHK CORE
   ========================================================================== */
jQuery(document).ready(function($) {
  /* LOCAL HELPER FUNCTIONS */
  /**
   * Reference: https://davidwalsh.name/query-string-javascript
   * @param  {string} name
   * @return {string} paratmeters in url
   */
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);

    return (results === null) ?
      '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  /**
   * Look for the corresponding JSON object from the given slug
   * @param  {string} slug
   * @param  {object} collection
   * @return {object} the desired object
   */
  function slugToObj(slug, collection) {
    return _.find(collection, function(obj) {
      return obj.slug === slug;
    });
  }

  /* PROGRAMME FINDER */
  if ($('.programme-finder').length) {
    Vue.component('multiselect', VueMultiselect.Multiselect);
    new Vue({
      el: '#programme-finder',
      data: {
        isLoading: true,
        elevelsList: phpVars.elevelsList,
        interestsList: phpVars.interestsList,
        filter: {
          elevels:
            slugToObj(getUrlParameter('elevels'), phpVars.elevelsList),
          interests:
            slugToObj(getUrlParameter('interests'), phpVars.interestsList),
        },
        listings: {},
        modal: {},
      },
      methods: {
        getListings: function() {
          if (!$('body').hasClass('home')) {
            this.isLoading = true;

            let parameters = {
              'per_page': 99,
              'orderby': 'rand',
              '_embed': 1,
              'lang': phpVars.siteLangCode,
            };

            if (this.filter.elevels) {
              parameters['filter[elevels]'] = this.filter.elevels.slug;
            }

            if (this.filter.interests) {
              parameters['filter[interests]'] = this.filter.interests.slug;
            }

            let that = this;

            $.ajax({
              url: decodeURI(phpVars.siteLangURL) + 'wp-json/' +
                   wpApiSettings.versionString + 'listings',
              data: parameters,
            })
            .done(function(data, status, xhr) {
              that.listings = data;
            })
            .always(function() {
              that.isLoading = false;
            });
          } else {
            let elevel =
              (this.filter.elevels) ? this.filter.elevels.slug : '';
            let interest =
              (this.filter.interests) ? this.filter.interests.slug : '';
            window.location.href =
              decodeURI(phpVars.siteLangURL) +
              'programme-finder/?elevels='+ elevel +
              '&interests=' + interest;
          }
        },
        resetFilters: function() {
          this.filter.elevels = null;
          this.filter.interests = null;
          this.getListings();
        },
        openModal: function(listing) {
          this.modal = listing;

          $('#modal-listing').foundation('open');
        },
      },
      mounted: function() {
        $(document).foundation();

        if ($('body').hasClass('page-template-template-programme-finder')) {
          this.getListings();
        }
      },
    });
  } else {
    $(document).foundation();
  }

  /* SLIDER */
  if ($('.slick').length) {
    $('.articles-slider .slick').slick({
      prevArrow:
        '<button type="button" class="slick-prev">' +
        '<span class="sr-only">Previous</span>' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next">' +
        '<span class="sr-only">Next</span>' +
        '</button>',
      autoplay: false,
      // centerMode: true,
      slidesToShow: 4,
      variableWidth: true,
    });
  }
});
